/**
 * Extract a column of data with specified field.
 */
export var Field = function Field(_ref) {
  var value = _ref.value;
  return function (data) {
    return data.map(function (d) {
      return d[value];
    });
  };
};
Field.props = {};